export default __webpack_public_path__ + "static/media/ic_btc_40.dca79332.svg";